export const entityProfileModalColors = {
  active: "#2563eb",
  activeMuted: "#3077eb",
  border: "#e5e7eb",
  borderStrong: "#d9e1ea",
  bodyText: "#0f172a",
  danger: "#e53e3e",
  disabledText: "#9aa4b2",
  editModeBg: "#eef2f7",
  empty: "#a0aec0",
  highlight: "#4f63f6",
  hoverTitle: "#0f2137",
  inputBorder: "#cfd6df",
  labelText: "#4a5568",
  muted: "#7b8494",
  mutedButtonText: "#9ca3af",
  navigationText: "#344054",
  panelBorder: "#edf0f2",
  panelHeaderBg: "#f8fafc",
  primaryButtonBg: "var(--chakra-colors-blue-500)",
  rowEditingBg: "#fbfdff",
  rowHighlightBg: "#f7fbff",
  secondaryText: "#526071",
  softBorder: "#dbe3ec",
  success: "#2f855a",
  surface: "white",
  surfaceMuted: "#fafafa",
  subtleBg: "#f7f8fa",
  subduedText: "#6b7280",
  text: "#1f2937",
  title: "#111827",
  uploadActionBlue: "#4c91f7",
  uploadActionBlueHover: "#3898ff",
} as const;

export const entityProfileModalBorders = {
  default: `1px solid ${entityProfileModalColors.border}`,
  panel: `1px solid ${entityProfileModalColors.panelBorder}`,
  soft: `1px solid ${entityProfileModalColors.softBorder}`,
  strong: `1px solid ${entityProfileModalColors.borderStrong}`,
} as const;
